<template>
    <BasePanel 
        headline="lang_LABEL_RELEASES_CAPTION_DIGITAL_DISTRIBUTION"
        :alvqa="alvqa"
    >
        <template v-slot:panelContent>
            <v-data-table
                :headers="headers"
                :items="items"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :header-props="{ sortIcon: '' }"
                :items-per-page="100"
            >
                <!-- Alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <!-- Items -->
                <template v-slot:[`item.logo`]="{ item }">
                    <div class="justify-left">
                        <v-img 
                            :src="require('@/assets/logo/digital_distribution/' + item.platformId.toLowerCase() + '-22px.png')" 
                            contain height="22px" 
                            position="left"
                        />
                    </div>
                </template>
                <template v-slot:[`item.platformCompany`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-company-platform-company'">
                        {{ getPlatformCompany(item.platformId) }}
                    </div>
                </template>
                <template v-slot:[`item.status`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-staus'">
                        <!-- {{ getStatus(item.staus) }} -->
                        {{ $t('lang_LABEL_RELEASES_DIGITAL_DISTRIBUTION_STATUS_DELIVERED') }}
                    </div>
                </template>
                <template v-slot:[`item.digitalRelease`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-digital-release-date'">
                        {{ getFormattedDate(item.digitalRelease) }}
                    </div>
                </template>
                <!-- <template v-slot:[`item.digitalPreRelease`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-prerelease-date'">
                        {{ getFormattedDate(item.digitalPreRelease) }}
                    </div>
                </template> -->
                <template v-slot:[`item.distributionTime`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.id + '-text-distribution-date'">
                        {{ getFormattedDate(item.distributionTime) }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'

export default {
    name:"ReleasesDigitalDistributionPanel",
    components: {
        BasePanel
    },
    props: {
        releaseAlvId: String
    },
    data() {
        return {
            alvqa: 'label-releases-list-row-' + this.releaseAlvId + '-read-only-panel-digital-distribution'
        }
    },
    computed: {
        items() {
            let release = this.$store.getters.getExpandedLabelReleases.find(release => {
                return release.alvId === this.releaseAlvId
            }) 

            return release.digitalDistributionLog
        },
        
        headers() {
            return [
                // {
                //     text: '', 
                //     align: 'center',
				// 	width: "60px", 
                //     value: "checkbox",
                //     alvqa: this.alvqa + '-header-checkbox'
                // },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_PLATFORM'), 
                    align: 'left',
                    value: "logo",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-logo'
                },
                {
                    text: this.$t('lang_GENERAL_CAPTION_COMPANY'), 
                    align: "left", 
                    value: "platformCompany",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-platform-company'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_STATUS'), 
                    align: "left", 
                    value: "status",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-status'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DISTRIBUTION_DATE'), 
                    align: "left", 
                    value: "distributionTime",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-distribution-date'
                },
                {
                    text: this.$t('lang_LABEL_RELEASES_CAPTION_DATE_DIGITAL'), 
                    align: "left", 
                    value: "digitalRelease",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-digital-release-date'
                }
            ]
        }
    },
    methods: {
        getFormattedDate(date) {  
            if(date === null || date === undefined) return ''
            else return this.$d(new Date(date), 'alvDateFormat') 
        },
        getPlatformCompany(platformId) {
            let platforms = this.$store.getters.getDigitalPlatforms

            if(platforms !== undefined) {
                return platforms.find(platform => {
                    return platform.platformId === platformId
                }).platformCompany
            }
        },
        // getStatus(status) {
        //     if(status === null) return ''
        //     if(status === 'sent') return 'Ausgeliefert'
        //     if(status === 'pending') return 'Vorgemerkt'
        // },
    },
    mounted() {
        this.$store.commit('setDigitalPlatforms')
    }
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
        table-layout: fixed;
    }
</style>